import Dashboard from '../../components/dashboard';
import { RdarrRoutingUrls } from '../../constants/routing/urls.constants';
import { MainDocumentationPagesConfig } from '../routes/dashboard-tabs/dashboard-tabs.config';

export const Routes = [
    // Dashboard Routing — pass the tab object so Dashboard can useState(activePage) like ERM-Portal Admin
    {
        path: RdarrRoutingUrls.base,
        component: Dashboard,
        props: { activePage: MainDocumentationPagesConfig[0] },
    },
    {
        path: RdarrRoutingUrls.rdarrReimagined,
        component: Dashboard,
        props: { activePage: MainDocumentationPagesConfig[0] },
    },
    {
        path: RdarrRoutingUrls.evidenceBasedApproach,
        component: Dashboard,
        props: { activePage: MainDocumentationPagesConfig[1] },
    },
    {
        path: RdarrRoutingUrls.sarbSelfAssessment,
        component: Dashboard,
        props: { activePage: MainDocumentationPagesConfig[2] },
    },
];
